export default __webpack_public_path__ + "static/media/logo.231f2a07.png";